<template>
  <button :class="arrowClass" />
</template>

<script>
export default {
  name: "OpenArrowButton",
  props: {
    arrowDirection: {
      type: String,
      default: ''
    }
  },
  computed: {
    arrowClass() {
      let results = ['c-open-arrow-button'];
      if (this.arrowDirection.length > 0) {
        results.push('c-open-arrow-button--' + this.arrowDirection)
      }
      return results
    }
  }
}

</script>

<style lang="scss" scoped>

.c-open-arrow-button {
  @include buttonReset;
  position: relative;
  height: 51px;
  width: 51px;
  border: $border;
  border-radius: 50px;
  cursor: pointer;
  @include themify($themes) {
    background-color: themed("background");
  }

  &::before {
    content: "";
    position: absolute;
    top: 17px;
    left: 23px;
    height: 9px;
    width: 2px;
    transform-origin: center;
    transform: rotate(45deg);
    @include themify($themes) {
      background-color: themed("foreground");
    }
  }

  &::after {
    content: "";
    position: absolute;
    top: 23px;
    left: 23px;
    height: 9px;
    width: 2px;
    transform-origin: center;
    @include themify($themes) {
      background-color: themed("foreground");
    }
  }

  &:hover {
    &::before {
      @include themify($themes) {
        background-color: themed("foreground", "x-light-text");
      }
    }

    &::after {
      @include themify($themes) {
        background-color: themed("foreground", "x-light-text");
      }
    }
  }

  &:active {
    &::before {
      @include themify($themes) {
        background-color: themed("foreground");
      }
    }

    &::after {
      @include themify($themes) {
        background-color: themed("foreground");
      }
    }
  }
  @include themify($themes) {
    border-color: themed('foreground', 'input-border');
  }

  &--left {
    &::before {
      left: 23px;
      transform: rotate(45deg);
    }

    &::after {
      left: 23px;
      transform: rotate(-45deg);
    }
  }

  &--right {
    &::before {
      left: 25px;
      transform: rotate(-45deg);
    }

    &::after {
      left: 25px;
      transform: rotate(45deg);
    }
  }
}

</style>
